<template>
  <TitledCard :title="$t('advanceCard')">
    <template #actions>
      <v-btn text color="primary" @click="openAdvanceDialog">{{ $t('newAdvanceButton') }}</v-btn>
    </template>
    <AdvanceDialog ref="advanceDialog" />
  </TitledCard>
</template>
<script>
export default {
  name: 'AdvanceCard',
  props: {
    committee: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openAdvanceDialog() {
      this.$refs.advanceDialog.openWithCommittee(this.committee)
    },
  },
}
</script>
